import 'twin.macro';
import { MinusIcon, PlusIcon } from '@heroicons/react/24/outline';

export function NotationRangeIndicator() {
  return (
    <div tw="flex flex-col items-center gap-2 self-stretch">
      <MinusIcon tw="w-5 h-5 text-neutral-supershy shrink-0" />
      <div tw="flex-1 w-px bg-neutral-moderate" />
      <PlusIcon tw="w-5 h-5 text-neutral-supershy shrink-0" />
    </div>
  );
}
